<lib-alert-modal-content
    [cancelButtonLabel]="''"
    confirmButtonLabel="Try again"
    headerIcon="clipboard-remove-fill"
    headerIconBackground="var(--ion-color-red-faded)"
    headerIconBackgroundColor="var(--ion-color-danger)"
    headerText="Error">
    <p>Sorry, we are unable to process your request.</p>
    <p *ngIf="formattedErrors">
        <span class="text-primary">The reason:&nbsp;</span>
        {{ formattedErrors }}
    </p>
</lib-alert-modal-content>
